import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import swal from "sweetalert2";

@Component({
  selector: "app-archived",
  templateUrl: "./archived.component.html",
  styleUrls: ["./archived.component.css"]
})
export class ArchivedComponent implements OnInit {
  archivedUsersData:any = [];
  currentPage2:any;
  pagination2 = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  sortType: any;
  totalCount: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  archiveUserSearch = "";
  closeSearch2:boolean = false;

  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService) { }

  ngOnInit(): void {
    this.getArchivedUsers();
  }
 
  getArchivedUsers(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination2.skip.toString());
    params = params.append("limit", this.pagination2.limit.toString());
    params = params.append("isArchive", 1);
    if (this.archiveUserSearch != null && this.archiveUserSearch != "") {
      params = params.append("search", this.archiveUserSearch);
    }
    if (this.sortBy) { params = params.append("sortBy",this.sortBy.trim() ? this.sortBy.trim() : "");
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._users,params)
    .subscribe(async (res) => {
      this.pagination2.totalItems = res.data.count; 
      this.totalCount = res.data.count; 
      this.archivedUsersData = res.data.users;
    })
  } 
  // =============== For Archived Users
  pageChanged2(event: any): void {
    if (event == this.currentPage2) return;
    this.currentPage2 = event;
    this.pagination2.skip = (event - 1) * this.pagination2.limit;
    window.scroll(0, 0);
    this.getArchivedUsers();
  }
  searchFun2() {  
    this.currentPage2 = 1;
    this.pagination2.skip = 0; 
    this.closeSearch2 = true; 
    if(this.archivedUsersData.length > 0){
      this.getArchivedUsers(); 
    }
    }
  clearSearch2() {
    this.archiveUserSearch= "";
    this.closeSearch2 = false;
    this.pagination2.skip = 0; 
    localStorage.removeItem("type-redirect");
    // if(this.archivedUsersData.length > 0){
      this.getArchivedUsers(); 
    // }
  }

  updateStatus(id,isArchive){
    let text;
    let status
    if(isArchive == 0){
      text = "<p>Are you sure you want to archive this user ?</p>";
      status = 1;
    }else{
      text = "<p>Are you sure you want to active this user ?</p>";
      status = 0;
    }
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) { 
        const data = {
          "id": id, 
          "isArchive": status, 
        }
        this.api.putData(apiUrl._users, data).subscribe(res => {
          this.getArchivedUsers();
        })
      }
    });
  }

  goToLinkedInUrl(url){
    window.open(url,"_blank")
  }
}